import React from "react";
import { useSelector } from "react-redux";
import ProtectedContainer from "./ProtectedContainer";
import NonProtectedContainer from "./NonProtectedContainer";
import { Box, ThemeProvider, createTheme } from "@mui/material";
import { theme } from "../../config/theme";
import FullPageLoader from "../Loader/FullPageLoader";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { googleLoginEnabled } from "../../config/constants";

export default function CoreContainer(props) {
  let uid = useSelector((state) => state?.auth?.uid);
  let authLoading = useSelector((state) => state?.auth?.authLoading);
  let chechUserExistLoading = useSelector(
    (state) => state?.auth?.chechUserExistLoading,
  );
  let cmmonLoading = useSelector((state) => state?.common?.loading);
  const appSettings = useSelector((state) => state?.common?.appSettings);
  const loading = authLoading || chechUserExistLoading || cmmonLoading;
  const googleLogin = appSettings?.find(
    (set) => set.name === googleLoginEnabled,
  )
    ? appSettings?.find((set) => set.name === googleLoginEnabled)?.value
        ?.enabled
    : true;

  const { comp } = props;

  console.log(
    "UID",
    uid,
    appSettings,
    appSettings?.find((set) => set.name === googleLoginEnabled)?.value?.enabled,
  );

  return (
    <ThemeProvider theme={createTheme(theme)}>
      {!googleLogin ? (
        <>
          {loading && <FullPageLoader />}
          {uid ? (
            <ProtectedContainer key={window.location.pathname}>
              {comp}
            </ProtectedContainer>
          ) : (
            <NonProtectedContainer key={window.location.pathname}>
              {comp}
            </NonProtectedContainer>
          )}
        </>
      ) : (
        <GoogleOAuthProvider clientId="698154870513-30bb3a3v2ef65m5co6b40gho4oac6lv1.apps.googleusercontent.com">
          {loading && <FullPageLoader />}
          {uid ? (
            <ProtectedContainer key={window.location.pathname}>
              {comp}
            </ProtectedContainer>
          ) : (
            <NonProtectedContainer key={window.location.pathname}>
              {comp}
            </NonProtectedContainer>
          )}
        </GoogleOAuthProvider>
      )}
    </ThemeProvider>
  );
}
